export const enumProveedorStep = {
    DatosCompania: 0,
    GiroPrincipal: 1,
    DomicilioFiscal: 2,
    InformacionComplementaria: 3,
    EnviarSolicitud: 4,
    SolicitudEnviada: 5,
};

export const enumPager = [10, 50, 200, 500];

export const enumPaisMex = "MÉXICO";
export const enumPaisMexCode = "MX";
export const enumPaisMexico = { sCodigoPais: enumPaisMexCode, sPais: enumPaisMex };

export const enumMaxWidth = 1100;
//export const maxFileSize = 18874368; //18MB
export const maxFileSize = 10485760; //10MB
